export default {
    sortImage: {
        marginRight: '16px'
    },
    dropableContainer: {
        maxHeight: '80%',
        overflow: 'auto'
    },
    fullWidth: {
        width: '100%'
    },
    listContainer: {
        paddingBottom: '2px',
    }
}